import { render, staticRenderFns } from "./GeoFile.vue?vue&type=template&id=4f826b76&scoped=true&"
import script from "./GeoFile.vue?vue&type=script&lang=js&"
export * from "./GeoFile.vue?vue&type=script&lang=js&"
import style0 from "./GeoFile.vue?vue&type=style&index=0&id=4f826b76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f826b76",
  null
  
)

export default component.exports